module.exports = __webpack_public_path__ + "img/User.26c017f8.svg";